import React from 'react';
import styles from './OMTitle.scss';

const OMTitle = properties => (
  <h1 className={styles[properties.className]}>
    {properties.title}
  </h1>
);

export default OMTitle;
